import Stack from '@mui/material/Stack';
// import CTInformation from './partials/CTInformation';
import Collapse from '@mui/material/Collapse';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import Documents from './partials/Documents';
import Images from './partials/Images';
import Information from './partials/Informations';
// import Merchandises from './partials/Merchandises';
import Payments from './partials/Payments';
// import PRPInformations from './partials/PRPInformations';
import { useEffect, useState } from 'react';
import { getAPI, postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import PaymentDetail from './partials/PartDetail/PaymentDetail';
import QuotationDetail from './partials/PartDetail/QuotationDetail';
import ReserveDetail from './partials/PartDetail/ReserveDetail';
import Quotations from './partials/Quotations';
import Reservation from './partials/Reservation';
import Schemas from './partials/Schemas';
import DialogShowRegisterAlert from './partials/dialog/DialogShowRegisterAlert';
import DialogForm from 'src/components/quotations/DialogForm';
import ConfirmDelete from 'src/components/common/modal/ConfirmDelete';
import DialogFormPayment from 'src/components/quotations//Payment/DialogForm';
import { getField } from 'src/common/helper';
import { useNotify } from 'src/context/ContextNotify';
// import Tasks from './partials/Tasks';
// import Treatments from './partials/Treatments';
// import VISIAPhotography from './partials/VISIAPhotography';

const DataDialogPaymentDefine = {
  paymentid: 0,
  patientid: 0,
  caseid: 0,
  quoteid: 0,
  open: false,
};

const DataDialogDefine = {
  id: 0,
  patientid: 0,
  open: false,
};

type DataDialogConfirm = {
  id: number | undefined;
  open: boolean;
};

type DataDialogType = {
  id: number;
  patientid: number;
  open: boolean;
};
interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

const a11yProps = (index: number) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
};

const View = (props: any) => {
  const notifyContext = useNotify();
  const patient = props.patient;
  const [layoutFull, setLayoutFull] = useState(false);
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [openReserve, setOpenReserve] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);
  const [openQuote, setOpenQuote] = useState(false);
  const [reservationDetail, setReservationDetail] = useState<any>(null);
  const [paymentDetail, setPaymentDetail] = useState<any>(null);
  const [quoteDetail, setQuoteDetail] = useState<any>(null);
  const [openRegisterAlert, setOpenRegisterAlert] = useState(false);
  const [dataDialogForm, setDataDialogForm] =
    useState<DataDialogType>(DataDialogDefine);
  const [dataDialogPayment, setDataDialogPayment] = useState<{
    paymentid: number;
    patientid: number;
    caseid: number;
    quoteid: number;
    open: boolean;
  }>(DataDialogPaymentDefine);
  const [dataDialogConfirm, setdataDialogConfirm] = useState<DataDialogConfirm>(
    {
      id: undefined,
      open: false,
    }
  );

  useEffect(() => {
    if (patient && patient.patient.alert) {
      setOpenRegisterAlert(true);
    }
  }, [patient]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleChangeLayout = (checked: boolean) => {
    setLayoutFull(checked);
  };

  const getColorTab = (value: number) => {
    let color = '#FFCE54';
    switch (value) {
      case 0:
        color = '#FFCE54';
        break;
      case 1:
        color = '#4FC1E9';
        break;
      case 2:
        color = '#656D78';
        break;
      case 3:
        color = '#ED5565';
        break;
      case 4:
        color = '#8CC152';
        break;
      case 5:
        color = '#656D78';
        break;
      default:
        break;
    }
    return color;
  };

  const handleReserveDetail = (id: any) => {
    const token = getToken();
    getAPI(
      `/reserve/detail?patientid=${patient?.patient?.id}&id=${id}&token=${token}`
    )
      .then((res) => {
        if (res.code === 200) {
          setReservationDetail(res.data);
          setOpen(true);
          setOpenReserve(true);
          setOpenPayment(false);
          setOpenQuote(false);
          setLayoutFull(true);
          setValue(1);
        }
      })
      .finally(() => {});
  };

  const handleQuotationDetail = (id: any) => {
    const token = getToken();
    getAPI(
      `/patient/quote-view?patientid=${patient?.patient?.id}&id=${id}&token=${token}`
    )
      .then((res) => {
        if (res.code === 200) {
          setQuoteDetail(res.data);
          setOpen(true);
          setOpenReserve(false);
          setOpenPayment(false);
          setOpenQuote(true);
          setLayoutFull(true);
          setValue(3);
        }
      })
      .finally(() => {});
  };

  const handlePaymentDetail = (id: any) => {
    const token = getToken();
    getAPI(
      `/patient/payment-view?patientid=${patient?.patient?.id}&id=${id}&token=${token}`
    )
      .then((res) => {
        if (res.code === 200) {
          setPaymentDetail(res.data);
          setOpen(true);
          setOpenReserve(false);
          setOpenPayment(true);
          setOpenQuote(false);
          setLayoutFull(true);
          setValue(5);
        }
      })
      .finally(() => {});
  };

  const handleCloseDetail = () => {
    setOpen(false);
    setOpenReserve(false);
    setOpenPayment(false);
    setOpenQuote(false);
  };

  const handleCloseDialogRegisterAlert = () => {
    setOpenRegisterAlert(false);
  };

  const handleAddQuote = (data: any | undefined) => {
    setDataDialogForm({
      open: true,
      id: 0,
      patientid: patient?.patient?.id,
    });
  };

  const handleCloseConfirm = () => {
    setdataDialogConfirm({
      id: undefined,
      open: false,
    });
  };

  const handleClickDelete = (data: any | undefined) => {
    const id = getField(data, 'id', 0);

    if (id) {
      handleCloseDialogForm();

      setdataDialogConfirm({
        id: Number(id),
        open: true,
      });
    }
  };
  const callAPIDelete = (id: number | undefined) => {
    if (id) {
      try {
        const token = getToken();

        const data = {
          patientid: patient?.patient?.id,
          id,
        };

        postAPI(`/patient/quote-delete?token=${token}`, data)
          .then((res) => {
            handleCloseConfirm();
            if (res.code === 200) {
              notifyContext.setNotifyMessage({
                show: true,
                message: '削除しました。',
                type: 'success',
              });
            }
            if (res.code === 501 || res.code === 500) {
              notifyContext.setNotifyMessage({
                show: true,
                message: res.msg,
                type: 'error',
              });
            }
          })
          .finally(() => {});
      } catch (error) {
        console.error('Failed to fetch data:', error);
        return;
      }
    }
  };

  const handleCloseDialogForm = (isRefreshList?: boolean) => {
    setDataDialogForm({
      ...DataDialogDefine,
    });
  };

  const handleCloseDialogFormPayment = (isRefreshList?: boolean) => {
    setDataDialogPayment(DataDialogPaymentDefine);
  };

  const handleClickPayment = (info: any) => {
    setDataDialogPayment({
      ...info,
      open: true,
    });

    if (dataDialogForm.open) {
      handleCloseDialogForm();
    }
  };

  const handleEditQuote = (patientid: number, quoteid: number) => {
    setDataDialogForm({
      open: true,
      id: quoteid,
      patientid: patientid
    });
  }

  return (
    <Stack width={'100%'}>
      <Information
        patient={patient?.patient || null}
        handleChangeLayout={handleChangeLayout}
        layoutFull={layoutFull}
      />
      <Stack direction={'row'} flex={1}>
        {layoutFull ? (
          <Stack flex={1} width={'50%'}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant='fullWidth'
              aria-label='full width tabs'
              sx={{
                bgcolor: 'primary.light',
                '&.MuiTabs-root .MuiTabs-indicator': {
                  bgcolor: getColorTab(value),
                  top: 0,
                },
                '& .MuiButtonBase-root.MuiTab-root': {
                  color: '#A3AED0',
                  fontSize: '14px',
                  fontWeight: 700,
                },
                '& .MuiButtonBase-root.MuiTab-root.Mui-selected': {
                  color: getColorTab(value),
                },
              }}
            >
              <Tab label={'カルテ'} {...a11yProps(0)} />
              <Tab label={'予約'} {...a11yProps(1)} />
              <Tab label={'画像'} {...a11yProps(2)} />
              <Tab label={'見積'} {...a11yProps(3)} />
              <Tab label={'文書'} {...a11yProps(4)} />
              <Tab label={'入金'} {...a11yProps(5)} />
            </Tabs>
            <TabPanel value={value} index={0}>
              <Schemas
                kartes={patient?.kartes || null}
                patient={patient?.patient || null}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Reservation
                reserves={patient?.reserves || null}
                patient={patient?.patient || null}
                handleReserveDetail={handleReserveDetail}
              />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Images
                images={patient?.images || null}
                patient={patient?.patient || null}
              />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <Quotations
                quotes={patient?.quotes || null}
                patient={patient?.patient || null}
                handleQuotationDetail={handleQuotationDetail}
                handleAddQuote={handleAddQuote}
              />
            </TabPanel>
            <TabPanel value={value} index={4}>
              <Documents
                docs={patient?.docs || null}
                patient={patient?.patient || null}
              />
            </TabPanel>
            <TabPanel value={value} index={5}>
              <Payments
                payments={patient?.payments || null}
                patient={patient?.patient || null}
                handlePaymentDetail={handlePaymentDetail}
              />
            </TabPanel>
          </Stack>
        ) : (
          <Stack flex={1} width={'50%'}>
            <Stack direction={'row'} spacing={'20px'}>
              <Stack width={'49%'}>
                <Schemas
                  kartes={patient?.kartes || null}
                  patient={patient?.patient || null}
                />
                <Images
                  images={patient?.images || null}
                  patient={patient?.patient || null}
                />
                <Documents
                  docs={patient?.docs || null}
                  patient={patient?.patient || null}
                />
                {/* Hide unuse menu as of now */}
                {/* <PRPInformations />
          <VISIAPhotography />
          <Treatments /> */}
              </Stack>
              <Stack width={'49%'}>
                <Reservation
                  reserves={patient?.reserves || null}
                  patient={patient?.patient || null}
                  handleReserveDetail={handleReserveDetail}
                />
                <Quotations
                  quotes={patient?.quotes || null}
                  patient={patient?.patient || null}
                  handleQuotationDetail={handleQuotationDetail}
                  handleAddQuote={handleAddQuote}
                />
                <Payments
                  payments={patient?.payments || null}
                  patient={patient?.patient || null}
                  handlePaymentDetail={handlePaymentDetail}
                />
                {/* Hide unuse menu as of now */}
                {/* <Tasks />
          <CTInformation />
          <Merchandises /> */}
              </Stack>
            </Stack>
          </Stack>
        )}
        <Collapse orientation='horizontal' in={open} collapsedSize={0}>
          <Stack
            flex={1}
            width={'35vw'}
            bgcolor={'primary.light'}
            ml={'20px'}
            position={'relative'}
          >
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='icon eye'
              sx={{
                width: '24px',
                height: '24px',
                position: 'absolute',
                right: '10px',
                top: '10px',
                cursor: 'pointer',
              }}
              onClick={handleCloseDetail}
            />
            {openReserve && (
              <ReserveDetail reservationDetail={reservationDetail} />
            )}
            {openQuote && <QuotationDetail quoteDetail={quoteDetail} handleEditQuote={handleEditQuote}/>}
            {openPayment && <PaymentDetail paymentDetail={paymentDetail} />}
          </Stack>
        </Collapse>
      </Stack>
      <DialogShowRegisterAlert
        open={openRegisterAlert}
        onClose={handleCloseDialogRegisterAlert}
        textAlert={patient?.patient.alert || ''}
      />

      <DialogForm
        open={dataDialogForm.open}
        patientId={dataDialogForm.patientid}
        quoteId={dataDialogForm.id}
        onClose={handleCloseDialogForm}
        onDelete={handleClickDelete}
        openFormPayment={handleClickPayment}
      />

      <DialogFormPayment
        open={dataDialogPayment.open}
        infoPayment={dataDialogPayment}
        onClose={handleCloseDialogFormPayment}
      />

      <ConfirmDelete
        openConfirm={dataDialogConfirm.open}
        handleCloseConfirmDelete={handleCloseConfirm}
        handleDelete={() => callAPIDelete(dataDialogConfirm.id)}
      />
    </Stack>
  );
};

export default View;
